export const SET_PROFESSIONAL_CAPTATION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const { data, id_profissional } = payload
    state.professionalCaptation.data = data
    state.professionalCaptation.idProfessional = id_profissional
    state.professionalCaptation.lastUpdate = new Date()
  }
}
export const SET_PROFESSIONAL_CAPTATION_LOADING = (state, payload) => {
  state.professionalCaptation.loading = payload
}

export const SET_PROFESSIONAL_SEGMENTATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const { data, idProfessional } = payload
    state.professionalSegmentations.data = data
    state.professionalSegmentations.idProfessional = idProfessional
    state.professionalSegmentations.lastUpdate = new Date()
  }
}
export const SET_PROFESSIONAL_SEGMENTATIONS_LOADING = (state, payload) => {
  state.professionalSegmentations.loading = payload
}

export const SET_PROFESSIONALSEGMENTATIONSHISTORICAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const { data, idProfessional } = payload
    state.professionalSegmentationsHistorical.data = data
    state.professionalSegmentationsHistorical.idProfessional = idProfessional
    state.professionalSegmentationsHistorical.lastUpdate = new Date()
  }
}
export const SET_PROFESSIONALSEGMENTATIONSHISTORICAL_LOADING = (
  state,
  payload
) => {
  state.professionalSegmentationsHistorical.loading = payload
}

export const SET_VALUATION_HOLDING = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.valuationHolding.data = payload
    state.valuationHolding.lastUpdate = new Date()
  }
}
export const SET_VALUATION_HOLDING_LOADING = (state, payload) => {
  state.valuationHolding.loading = payload
}

export const SET_PJ_PARTNERSHIP = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.PJPartnership.data[payload.id] = {}
    state.PJPartnership.data[payload.id].data = payload
    state.PJPartnership.data[payload.id].lastUpdate = new Date()
  }
}
export const SET_PJ_PARTNERSHIP_LOADING = (state, payload) => {
  if (state.PJPartnership.data[payload.id]) {
    state.PJPartnership.data[payload.id].loading = payload.loading
  } else {
    state.PJPartnership.data[payload.id] = {
      loading: payload.loading,
    }
  }
}

export const SET_CUSTOMERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.customers.data = payload
    state.customers.lastUpdate = new Date()
  }
}
export const ADD_CUSTOMERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.customers.data.tasks.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.customers.data.tasks.push(data)
      }
    })
  }
}
export const SET_CUSTOMERS_LOADING = (state, payload) => {
  state.customers.loading = payload
}
export const SET_FAMILY_GROUP = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.familyGroup.data = payload
    state.familyGroup.lastUpdate = new Date()
  }
}
export const ADD_FAMILY_GROUP = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.familyGroup.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.familyGroup.data.push(data)
      }
    })
  }
}
export const SET_FAMILY_GROUP_LOADING = (state, payload) => {
  state.familyGroup.loading = payload
}

export const SET_CUSTOMERS_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.customersPartners.data = payload
    state.customersPartners.lastUpdate = new Date()
  }
}
export const ADD_CUSTOMERS_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.customersPartners.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.customersPartners.data.push(data)
      }
    })
  }
}
export const SET_CUSTOMERS_PARTNERS_LOADING = (state, payload) => {
  state.customersPartners.loading = payload
}
export const SET_CALCULATOR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.calculator.data = payload
    state.calculator.lastUpdate = new Date()
  }
}
export const ADD_CALCULATOR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.calculator.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.calculator.data.push(data)
      }
    })
  }
}
export const SET_CALCULATOR_LOADING = (state, payload) => {
  state.calculator.loading = payload
}

export const SET_CAPTABLE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.captable.data = payload
    state.captable.lastUpdate = new Date()
  }
}
export const ADD_CAPTABLE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.captable.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.captable.data.push(data)
      }
    })
  }
}
export const SET_CAPTABLE_LOADING = (state, payload) => {
  state.captable.loading = payload
}

export const SET_CAPTABLE_FEES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.captableFees.data = payload
    state.captableFees.lastUpdate = new Date()
  }
}

export const ADD_CAPTABLE_FEES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.captableFees.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.captableFees.data.push(data)
      }
    })
  }
}

export const SET_CAPTABLE_FEES_LOADING = (state, payload) => {
  state.captableFees.loading = payload
}

export const SET_CONTROL_PARTNERSHIP = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.controlPartnership.data = payload
    state.controlPartnership.lastUpdate = new Date()
  }
}
export const ADD_CONTROL_PARTNERSHIP = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.controlPartnership.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.controlPartnership.data.push(data)
      }
    })
  }
}
export const SET_CONTROL_PARTNERSHIP_LOADING = (state, payload) => {
  state.controlPartnership.loading = payload
}

export const SET_CONTROL_SUMMARY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.controlSummary.data = payload
    state.controlSummary.lastUpdate = new Date()
  }
}
export const ADD_CONTROL_SUMMARY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.controlSummary.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.controlSummary.data.push(data)
      }
    })
  }
}
export const SET_CONTROL_SUMMARY_LOADING = (state, payload) => {
  state.controlSummary.loading = payload
}
export const SET_RANKING_CAPTACAO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.rankingCaptacao.data = payload
    state.rankingCaptacao.lastUpdate = new Date()
  }
}
export const ADD_RANKING_CAPTACAO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.rankingCaptacao.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.rankingCaptacao.data.push(data)
      }
    })
  }
}
export const SET_RANKING_CAPTACAO_LOADING = (state, payload) => {
  state.rankingCaptacao.loading = payload
}

export const SET_MIX_COMMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.mixComments.data = payload
    state.mixComments.lastUpdate = new Date()
  }
}
export const ADD_MIX_COMMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      if (!state.mixComments.data[data.id_cliente_partners]) {
        state.mixComments.data[data.id_cliente_partners] = []
      }
      let old = state.mixComments.data[data.id_cliente_partners].find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.mixComments.data[data.id_cliente_partners].push(data)
      }
    })
  }
}
export const SET_MIX_COMMENTS_LOADING = (state, payload) => {
  state.mixComments.loading = payload
}

export const SET_ORCADO_REALIZADO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.orcadoRealizado.data = payload
    state.orcadoRealizado.lastUpdate = new Date()
  }
}
export const ADD_ORCADO_REALIZADO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.orcadoRealizado.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.orcadoRealizado.data.push(data)
      }
    })
  }
}
export const SET_ORCADO_REALIZADO_LOADING = (state, payload) => {
  state.orcadoRealizado.loading = payload
}
